import React from 'react';
import {
  SideNavSectionStyled as SideNavSection,
  SideNavMenuStyled as SideNavMenu,
} from './styles/SideNavStyled';
import Menu from '../Menu';
import Header from '../Header/Header';

const SideNav = () => {
  return (
    <SideNavSection>
      <Header />
      <SideNavMenu>
        <Menu />
      </SideNavMenu>
    </SideNavSection>
  );
};

export default SideNav;
